import React from 'react';
import './skills.css';

const Skills = () => (
    <section id="skills">
        <h2 className="skillTitle">Mentorship with purpose</h2>
        <p className="skillDesc">I am Godfrey Kuteesa, President of the Boys' Mentorship Programme in Uganda. My work centres on helping boys grow into responsible men through Christian values, practical learning and guidance.</p>
        <div className="skillBars">
            <div className="skillBar"><div className="skillBarText">
                <h3>Character &amp; responsibility</h3>
                <p>Encouraging integrity, respect for others and responsibility for everyday choices.</p>
            </div></div>
            <div className="skillBar"><div className="skillBarText">
                <h3>Leadership &amp; life skills</h3>
                <p>Helping boys practise teamwork, communication and service through hands-on learning.</p>
            </div></div>
            <div className="skillBar"><div className="skillBarText">
                <h3>Faith &amp; purpose</h3>
                <p>Sharing biblical principles that guide personal growth, family life and community responsibility.</p>
            </div></div>
        </div>
    </section>
);

export default Skills;
